import { render, staticRenderFns } from "./DocumentImagePager.vue?vue&type=template&id=1cd5e8cc&scoped=true&"
import script from "./DocumentImagePager.vue?vue&type=script&lang=js&"
export * from "./DocumentImagePager.vue?vue&type=script&lang=js&"
import style0 from "./DocumentImagePager.vue?vue&type=style&index=0&id=1cd5e8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5e8cc",
  null
  
)

export default component.exports